
export class PaginationOptionsDTO {
  constructor(options) {
    this.page = options.page || 1;
    this.limit = options.limit || 10;
    this.status = options.status;
  }
}